import CountdownBanner from './component'
export { CountdownBanner }
export default CountdownBanner